import { skipToken, useQuery } from "@tanstack/react-query";
import {
  getHunterPrerequisites,
  getHunterUserIDPrerequisites,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const HUNTER_PREREQUISITES_QUERY_KEY = "HUNTER_PREREQUISITES";

export const hunterPrerequisitesKeys = {
  all: [HUNTER_PREREQUISITES_QUERY_KEY] as const,
  byUserID: (userID?: number) =>
    [...hunterPrerequisitesKeys.all, userID] as const,
};

export const useHunterPrerequisitesQuery = () =>
  useQuery({
    queryKey: hunterPrerequisitesKeys.all,
    queryFn: processResponseWithApiProblemDetails(() =>
      getHunterPrerequisites(),
    ),
  });

export const useHunterPrerequisitesByUserIDQuery = (userID?: number) =>
  useQuery({
    queryKey: hunterPrerequisitesKeys.byUserID(userID),
    queryFn: userID
      ? processResponseWithApiProblemDetails(() =>
          getHunterUserIDPrerequisites(userID),
        )
      : skipToken,
  });
